import { getServiceWrapper } from 'core/service-wrapper'
import { createSelector } from 'reselect'
import { currentQQ } from './primitive-selector'
import { flow, toString } from 'lodash/fp'

const productCode = currentQQ('selectedDisplayProduct.code')
const basicPlanCode = currentQQ('selectedDisplayProduct.basicPlanCode')
const basicPlanName = currentQQ('selectedDisplayProduct.name')

const paymentPeriod = createSelector(
  [
    currentQQ('selectedDisplayProduct.paymentPeriod.type'),
    flow(currentQQ('selectedDisplayProduct.paymentPeriod.value'), toString),
  ],
  (type, value) => ({
    type,
    value,
  })
)

const coveragePeriod = createSelector(
  [
    currentQQ('selectedDisplayProduct.coveragePeriod.type'),
    flow(currentQQ('selectedDisplayProduct.coveragePeriod.value'), toString),
  ],
  (type, value) => ({
    type,
    value,
  })
)

export const product = createSelector(
  [productCode, basicPlanCode, paymentPeriod, coveragePeriod, basicPlanName],
  (code, basicPlanCode, paymentPeriod, coveragePeriod, basicPlanName) => ({
    code,
    basicPlanCode,
    paymentPeriod,
    coveragePeriod,
    basicPlanName,
  })
)

export const productMRTA = (state) => {
  const serviceWrapper = getServiceWrapper()
  if (serviceWrapper.isCurrentProductUsePartnerApi()) {
    const p = product(state)
    return {
      code: p.basicPlanCode,
      basicPlanCode: p.code,
      paymentPeriod: p.paymentPeriod,
      coveragePeriod: p.coveragePeriod,
      basicPlanName: p.basicPlanName,
    }
  } else {
    return product(state)
  }
}
